const shippingCards = [
  {
    icon: 'ri-truck-line',
    title: 'Free Shipping Over $49',
    desc: 'Orders over $49 ship free to anywhere in the contiguous United States. Most orders ship within 1–2 business days from our central warehouse.',
    highlight: 'Free on $49+',
  },
  {
    icon: 'ri-time-line',
    title: '1–2 Day Processing',
    desc: 'Orders placed before 3 PM EST ship same or next business day. We prioritize speed because we know you need your parts fast.',
    highlight: 'Same-Day Possible',
  },
  {
    icon: 'ri-map-2-line',
    title: 'Ships to All 50 States',
    desc: 'We ship nationwide — from Florida to Alaska. Landlords, property managers, and homeowners across the country rely on us for consistent delivery.',
    highlight: 'Nationwide Coverage',
  },
  {
    icon: 'ri-arrow-go-back-line',
    title: '30-Day Easy Returns',
    desc: 'Got the wrong part? Returns are simple and hassle-free. Contact us within 30 days of delivery and we\'ll get you sorted with a refund or exchange.',
    highlight: 'No-Hassle Returns',
  },
];

const orderSteps = [
  { num: '1', title: 'Find Your Part', desc: 'Browse by blind type or search by description or SKU' },
  { num: '2', title: 'Add to Cart', desc: 'Select quantity and add to your secure shopping cart' },
  { num: '3', title: 'We Ship Fast', desc: 'Order processed and shipped within 1–2 business days' },
  { num: '4', title: 'Fix Your Blinds', desc: 'Install in minutes with our easy-to-follow guides' },
];

export default function ShippingBenefits() {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-amber-600 text-xs font-bold tracking-widest uppercase mb-3">
            Nationwide Shipping
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-stone-900">
            Ordering Is Simple. Shipping Is Fast.
          </h2>
          <p className="text-stone-500 mt-3 text-base max-w-xl mx-auto">
            We make it easy to get the right part to your door — quickly, reliably, and affordably.
          </p>
        </div>

        {/* 4-step order flow */}
        <div className="relative grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {orderSteps.map((step, idx) => (
            <div key={step.num} className="relative flex flex-col items-center text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-amber-600 text-white text-xl font-bold rounded-full mb-4 z-10">
                {step.num}
              </div>
              {idx < orderSteps.length - 1 && (
                <div className="hidden lg:block absolute top-7 left-[calc(50%+2rem)] right-[calc(-50%+2rem)] h-px bg-amber-200 z-0" />
              )}
              <h3 className="font-bold text-stone-900 text-sm mb-1.5">{step.title}</h3>
              <p className="text-stone-500 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Shipping cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {shippingCards.map((card) => (
            <div key={card.title} className="bg-stone-50 rounded-lg border border-stone-200 p-6">
              <div className="w-11 h-11 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className={`${card.icon} text-amber-700 text-xl`} />
              </div>
              <span className="inline-block bg-amber-600 text-white text-[10px] font-bold px-2.5 py-1 rounded-sm mb-3 tracking-wide">
                {card.highlight}
              </span>
              <h3 className="font-bold text-stone-900 text-sm mb-2">{card.title}</h3>
              <p className="text-stone-500 text-xs leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
